import { Button, ButtonProps } from '@frontend/design-system';

export const HeaderIcon = (props: Partial<ButtonProps>) => {
  return (
    <Button
      variant='secondary'
      css={[
        {
          padding: 0,
          marginLeft: 'auto',
          height: '36px',
          width: '36px',
        },
      ]}
      size='large'
      {...props}
    ></Button>
  );
};
